export default "__VITE_ASSET__BBT3jOwm__"